/**
Author - Brijesh Pandey
Git - https://github.com/brijesh-pandey
**/

import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";

import GetStartedModal from "./GetStartedModal";

const propTypes = {
  rCode: PropTypes.string,
  resetPin: PropTypes.bool,
  setToggleModal: PropTypes.func,
  toggleModal: PropTypes.bool
};

const GetStartedModalContainer = ({
  setToggleModal,
  toggleModal,
  rCode,
  resetPin
}) => {
  const [userStep, setUserStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [rsessionId, setRsessionId] = useState("");
  const [userData, setUserData] = useState({});
  const [formData, setFormData] = useState({
    phoneNumber: "",
    email: "",
    password: ""
  });
  const [inputType, setInputType] = useState(null);

  useEffect(() => {
    if (toggleModal) {
      setUserStep(1);
      setUserData({});
      setFormData({
        phoneNumber: "",
        email: "",
        password: ""
      });
      setInputType(null);
    }
  }, [toggleModal]);


  return (
    <GetStartedModal
      isLoading={isLoading}
      rCode={rCode}
      resetPin={resetPin}
      rsessionId={rsessionId}
      setIsLoading={setIsLoading}
      setRsessionId={setRsessionId}
      setToggleModal={setToggleModal}
      setUserData={setUserData}
      setUserStep={setUserStep}
      toggleModal={toggleModal}
      userData={userData}
      userStep={userStep}
      formData={formData}
      inputType={inputType}
      setFormData={setFormData}
      setInputType={setInputType}
    />
  );
};

GetStartedModalContainer.propTypes = propTypes;

export default GetStartedModalContainer;
